module.exports = __webpack_public_path__ + "static/Devices-23fcc6ebf5050ea9f8cc8e2b83216745.png";